import { toast } from 'src/utils/notification';

const warningMessage = navigator.language === 'de-DE' 
  ? 'Um das System vollständig zu nutzen, müssen Sie Cookies akzeptieren. Bitte prüfen Sie Ihre Einstellungen' 
  : 'To fully use the system, you need to accept cookies. Please check your settings';

export const cookieDeclineToast = () => {
  toast.warning(warningMessage);
};